import React, { useState, useEffect } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import ApiService from '../services/ApiService'
import Nav from '../components/Nav'
import AuthService from '../hooks/AuthService';

const Memory = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const [memory, setMemory] = useState([])
    const [isCarouselOpen, setIsCarouselOpen] = useState(false);
    const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
    const [mediaType, setMediaType] = useState(''); 


    const openCarousel = (index, type) => {
        setCurrentMediaIndex(index);
        setMediaType(type);
        setIsCarouselOpen(true);
    };

    const closeCarousel = () => {
        setIsCarouselOpen(false);
    };

    const nextMedia = () => {
        if (mediaType === 'image') {
            setCurrentMediaIndex((prevIndex) => (prevIndex + 1) % memory[0]?.data?.gallery.length);
        } else if (mediaType === 'video') {
            setCurrentMediaIndex((prevIndex) => (prevIndex + 1) % 1);
        } else if (mediaType === 'pdf') {
            setCurrentMediaIndex((prevIndex) => (prevIndex + 1) % 1);
        }
    };

    const prevMedia = () => {
        if (mediaType === 'image') {
            setCurrentMediaIndex((prevIndex) => (prevIndex - 1 + memory[0]?.data?.gallery.length) % memory[0]?.data?.gallery.length);
        } else if (mediaType === 'video') {
            setCurrentMediaIndex((prevIndex) => (prevIndex - 1 + 1) % 1);
        } else if (mediaType === 'pdf') {
            setCurrentMediaIndex((prevIndex) => (prevIndex - 1 + 1) % 1);
        }
    };

    useEffect(() => {
        if (!AuthService.isAuthenticated()) {
            AuthService.logout(navigate);
        }
    }, [navigate]);

    const getMemory = async () => {
        try {
            const response = await ApiService.get(`/cms/memories?id=${id}`);
            if (response?.contents?.length > 0) {
                setMemory(response.contents);
            } else {
                console.warn("No clone data found.");
                setMemory([]);
            }
        } catch (err) {
            console.error("Error during fetching clone data:", err);
        }
    };

    useEffect(() => {
        getMemory()
    }, [id])

    const pdfs = memory[0]?.data?.pdf;

    return (
        <div className="tyn-root memories">
            {/* <Loading status={loading} blur={true}> */}
            <Nav />
            <div className="tyn-content tyn-add-clone">
                <div className="tyn-main tyn-content-inner" id="tynMain">
                    <div className="container">
                        <div className="tyn-profile d-flex align-items-center justify-content-between px-5 py-4" style={{ background: 'white', borderRadius: '1rem' }}>
                            <div>
                                <h3>
                                    {memory[0]?.data?.name
                                        ? `${memory[0]?.data?.name} - Memory of '${memory[0]?.data?.clone?.data?.name}'`
                                        : "..."}
                                </h3>                            </div>
                            <div className="buttons d-flex">
                                <Link className="btn btn-primary" to={`/edit-memory/${id}`} aria-label="Edit memory">
                                    Edit
                                </Link>
                                <Link className="btn btn-light" to="/clone-list" aria-label="Cancel and back to clone list">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" stroke="currentColor" strokeWidth="0.3" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                    </svg>
                                    Clone List
                                </Link>
                            </div>
                        </div>

                        <div className="tyn-profile mt-4">


                            <div className="tyn-profile-details">
                                <div className="tab-content">
                                    <div className="tab-pane show active" id="profile-edit" tabIndex="0">
                                        <div className="row gy-5">

                                            <div className="col-12">
                                                <div className="row gy-4">
                                                    <div className="col-lg-3">
                                                        <h6>Memory Details</h6>
                                                        <div className="tyn-subtext">See the memory information</div>
                                                    </div>
                                                    <div className="col-lg-9">
                                                        <div className="row g-gs">
                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label className="form-label" htmlFor="name">Title</label>
                                                                    <div className="form-control-wrap">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="memory-title"
                                                                            placeholder="Your Name"
                                                                            value={memory[0]?.data?.name || ""}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="form-group">
                                                                    <label className="form-label" htmlFor="birthday">Date</label>
                                                                    <div className="form-control-wrap" id='birthday'>
                                                                        <input
                                                                            type="date"
                                                                            className="form-control"
                                                                            id="memory-date"
                                                                            value={memory[0]?.data?.date || ""}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <label className="form-label" htmlFor="description">Description</label>
                                                                    <textarea className="form-control"
                                                                        id="description"
                                                                        placeholder="Description..."
                                                                        rows="4"
                                                                        value={memory[0]?.data?.description || ""}
                                                                        disabled
                                                                    >
                                                                    </textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="row gy-4">

                                                    <div className="col-lg-3">
                                                        <h6>Memory Gallery</h6>
                                                        <div className="tyn-subtext">See the memory media</div>
                                                    </div>

                                                    <div className="col-lg-9">
                                                        <div className="row g-gs">
                                                            <div className="col-lg-6">
                                                                <h6 className="tyn-overline">Image Gallery</h6>
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <div className="row g-3">
                                                                            {memory[0]?.data?.gallery.length > 0 && memory[0]?.data?.gallery.map((picture, index) => (
                                                                                <div className="col-4" key={index} style={{ position: 'relative' }}>
                                                                                    <Link className="glightbox tyn-thumb" data-gallery="media-photo">
                                                                                        <img src={picture?.media} className="tyn-image pointer" onClick={() => openCarousel(index, 'image')} alt={picture?.name} />
                                                                                    </Link>
                                                                                </div>
                                                                            )) || <span className='small'>No images attached.</span>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6">
                                                                <h6 className="tyn-overline">Video Gallery</h6>
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <div className="row g-3">
                                                                            {memory[0]?.data?.video?.media && (
                                                                                <div className="col-6" style={{ position: 'relative' }}>
                                                                                    <video controls width="100%" height="auto" onClick={() => openCarousel(0, 'video')} className='pointer'>
                                                                                        <source src={memory[0]?.data?.video?.media} type="video/mp4" />
                                                                                    </video>
                                                                                </div>
                                                                            ) || <span className='small'>No video attached.</span>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12">
                                                                <h6 className="tyn-overline">File Attachment</h6>
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <div className="row g-3">
                                                                            {memory[0]?.data?.pdf?.name && (
                                                                                <div className="col-6" style={{ position: 'relative' }}>
                                                                                    <Link to={'#'} onClick={() => openCarousel(0, 'pdf')} className="tyn-file">
                                                                                        <div className="tyn-media-group">
                                                                                            <div className="tyn-media tyn-size-lg text-bg-light">
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#2C629B" className="bi bi-filetype-pdf" viewBox="0 0 16 16">
                                                                                                    <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z" />
                                                                                                </svg>
                                                                                            </div>
                                                                                            <div className="tyn-media-col">
                                                                                                <h6 className="name">{memory[0]?.data?.pdf?.name}</h6>
                                                                                                <div className="meta">PDF Document</div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Link>
                                                                                </div>
                                                                            ) || <span className='small'>No document attached.</span>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isCarouselOpen && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        zIndex: 1050,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <button
                        onClick={closeCarousel}
                        style={{
                            position: 'absolute',
                            top: '20px',
                            right: '20px',
                            backgroundColor: 'transparent',
                            border: 'none',
                            fontSize: '24px',
                            color: 'white',
                            cursor: 'pointer',
                            zIndex: 1051,
                        }}
                        aria-label="Close carousel"
                    >
                        ✕
                    </button>

                    {mediaType === 'image' && (
                        <img
                            src={memory[0]?.data?.gallery[currentMediaIndex].media}
                            alt={memory[0]?.data?.gallery[currentMediaIndex].name}
                            style={{ maxHeight: '90%', maxWidth: '90%' }}
                        />
                    )}

                    {mediaType === 'video' && (
                        <video controls width="90%" height="auto">
                            <source src={memory[0]?.data?.video?.media} type="video/mp4" />
                        </video>
                    )}

                    {mediaType === 'pdf' && (
                        <iframe
                            src={memory[0]?.data?.pdf?.media}
                            style={{ width: '90%', height: '90%' }}
                            title="PDF Viewer"
                        ></iframe>
                    )}
                    {(mediaType === "image" && memory[0]?.data?.gallery.length > 1) &&
                        <>
                            <button
                                onClick={prevMedia}
                                style={{
                                    position: 'absolute',
                                    left: '20px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    fontSize: '24px',
                                    color: 'white',
                                    cursor: 'pointer',
                                    zIndex: 1051,
                                }}
                                aria-label="Previous media"
                            >
                                ←
                            </button>
                            <button
                                onClick={nextMedia}
                                style={{
                                    position: 'absolute',
                                    right: '20px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    fontSize: '24px',
                                    color: 'white',
                                    cursor: 'pointer',
                                    zIndex: 1051,
                                }}
                                aria-label="Next media"
                            >
                                →
                            </button>
                        </> || <></>}

                </div>
            )}
            {/* </Loading> */}
        </div >
    )
}

export default Memory